import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable @typescript-eslint/member-ordering */
import * as React from 'react';
import { polyfill } from 'react-lifecycles-compat';
import { isFunction } from '@utiljs/is';
import Loading from '../Loading';
import isEqual from 'lodash/isEqual';
import { debounce } from '@utiljs/functional';
import ReactResizeDetector from 'react-resize-detector';
import Colgroup from './Colgroup';
import TableHead from './TableHead';
import TableRow from './TableRow';
import RowSelection from './RowSelection';
import TableExpandRow from './TableExpandRow';
import ExpandArrow from './TableExpandArrow';
import TableTreeCell from './TableTreeCell';

function stopPropagation(e) {
  e.stopPropagation();

  if (e.nativeEvent.stopImmediatePropagation) {
    e.nativeEvent.stopImmediatePropagation();
  }
}

export function reduceKeys(keys) {
  return keys.reduce(function (m, k) {
    m[k] = true;
    return m;
  }, {});
}

var Table = /*#__PURE__*/function (_React$Component) {
  _inherits(Table, _React$Component);

  var _super = _createSuper(Table);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.call(this, props);
    _this.computedCache = {}; // 缓存计算值，每次render只计算一次

    _this.myRefs = {};
    _this.cacheRowHeightMap = {};
    /**
     * 扁平化数据用于支持 treeTable
     * _roo_key: 父级的 key 组合
     * _roo_index: tree 子级的 key 需要拼接父级 key
     * _roo_level: 数据层级
     */

    _this.flatTreeTable = function (tableData) {
      var flatData = [];
      var level = 0;

      var flat = function flat(data, key, parIndex) {
        data.forEach(function (item, index) {
          var rowKeyValue = _this.findRowKey(item, index);

          flatData.push(_Object$assign(_Object$assign({}, item), {
            _roo_key: key,
            _roo_index: level > 0 ? [].concat(_toConsumableArray(parIndex), [index + 1]).join('-') : index + 1,
            _roo_level: level
          }));

          if (item.children) {
            level += 1;
            flat(item.children, key.concat([rowKeyValue]), parIndex.concat([index + 1]));
          }
        });
        level -= 1;
      };

      flat(tableData, [], []);
      return flatData;
    }; // get scrollUnsetStyle(): React.CSSProperties {
    //     // if (!this.dataSource.length) {
    //     //     return {
    //     //         overflow: 'unset'
    //     //     };
    //     // }
    //     return {};
    // }


    _this.handleForceUpdate = function () {
      _this.forceUpdate();
    };

    _this.findRowKey = function (record, index) {
      var rowKey = _this.props.rowKey;
      if (typeof rowKey === 'string') return record[rowKey];
      if (typeof rowKey === 'function') return rowKey(record, index);
      return index;
    };

    _this.findSelectionPropsByItem = function (item, index) {
      var getSelectionProps = _this.props.getSelectionProps;

      if (!getSelectionProps) {
        return {};
      }

      return getSelectionProps(item, index);
    };
    /**
     * 将可能包含 children 字段的 columns 处理成body所需要的 columns
     */


    _this.normalizeBodyColumns = function (cols) {
      return cols.reduce(function (arr, c) {
        if (c.children && c.children.length) return arr.concat(_this.normalizeBodyColumns(c.children));
        arr.push(c);
        return arr;
      }, []);
    };
    /**
     * Fixed: 解决fixed行高度不一致的问题
     * 解决思路是将main table的每一行高度都存起来，然后分发给不同行
     */


    _this.syncHeightOfIndex = function (index, height) {
      if (_this.cacheRowHeightMap[index] !== height) {
        _this.cacheRowHeightMap[index] = height;

        _this.syncHeight();
      }
    };

    _this.syncHeight = debounce(function () {
      _this.setState({
        rowHeightMap: _Object$assign({}, _this.cacheRowHeightMap)
      });
    }, 200);

    _this.registerTreeColumn = function (columns) {
      if (!(columns && columns.length)) {
        return;
      }

      var first = columns[0];
      columns[0] = _Object$assign(_Object$assign({}, first), {
        render: function render(text, record, index) {
          var key = _this.findRowKey(record, index);

          var expand = _this.expandRowKeyMap[key];
          var callbackProps = [record, index, !expand];
          return /*#__PURE__*/React.createElement(TableTreeCell, {
            text: text,
            index: index,
            expanded: expand,
            data: record,
            onClick: function onClick() {
              return _this.handleChangeExpand(key, !expand, callbackProps);
            }
          });
        }
      });
    };

    _this.handleSort = function (sortParam) {
      _this.props.onSortChange(sortParam.prop, sortParam.order);

      _this.setState({
        sortOrder: sortParam
      });
    };

    _this.handleCellClick = function (key, data, event) {
      var column = _this.columns.find(function (c) {
        return c.prop === key;
      });

      if (column && column.onCellClick) column.onCellClick(data[key], data, event);
    };

    _this.handleRadioSelect = function (e, record, index) {
      var newMap = {};

      var rowKey = _this.findRowKey(record, index);

      if (e.target.checked) {
        newMap[rowKey] = true;
      } else {
        delete newMap[rowKey];
      }

      _this.setState({
        selectionKeyMap: newMap
      });

      _this.handleSelectChange(newMap);
    };

    _this.handleSelect = function (e, record, index) {
      var rowKey = _this.findRowKey(record, index);

      var newMap = _Object$assign({}, _this.selectionKeyMap);

      if (e.target.checked) {
        newMap[rowKey] = true;
      } else {
        delete newMap[rowKey];
      }

      _this.handleSelectChange(newMap);
    };

    _this.handleSelectAll = function (e) {
      var newMap = {};

      if (e.target.checked) {
        _this.checkableKeys.forEach(function (v) {
          newMap[v] = true;
        });
      }

      _this.handleSelectChange(newMap);
    };

    _this.handleSelectChange = function (keyMap) {
      var onSelectionChange = _this.props.onSelectionChange;

      _this.setState({
        selectionKeyMap: keyMap
      });

      var selectedKeys = _Object$keys(keyMap).filter(function (k) {
        return keyMap[k];
      });

      if (onSelectionChange) onSelectionChange(selectedKeys);
    };

    _this.handleChangeExpand = function (rowKey, expanded, callbackProps) {
      var keyMap = _Object$assign({}, _this.expandRowKeyMap);

      keyMap[rowKey] = expanded;

      _this.setState({
        expandRowKeyMap: keyMap
      }, function () {
        var onExpandChange = _this.props.onExpandChange;

        if (isFunction(onExpandChange)) {
          onExpandChange.apply(void 0, _toConsumableArray(callbackProps));
        }
      });
    };

    _this.handleScroll = function (e) {
      // 要不要节流，这是个问题？？
      if (e.currentTarget !== e.target) return;
      var dom = e.target;
      var scrollY = _this.props.scrollY;
      var _this$myRefs = _this.myRefs,
          thead = _this$myRefs.thead,
          tbody = _this$myRefs.tbody,
          fixedLeft = _this$myRefs.fixedLeft,
          fixedRight = _this$myRefs.fixedRight;

      var syncScrollTop = function syncScrollTop(t, el, prop) {
        if (el && el !== t) {
          el[prop] = t[prop];
        }
      };

      if (scrollY) {
        // 启用了 scrollable 样式
        var scrollTop = dom.scrollTop,
            scrollLeft = dom.scrollLeft;

        if (_this.lastScrollLeft !== scrollLeft && dom !== fixedLeft && dom !== fixedRight) {
          // 同步水平滚动
          syncScrollTop(dom, thead, 'scrollLeft');
          syncScrollTop(dom, tbody, 'scrollLeft'); // 设置fixed阴影样式

          _this.computedScrollPositionClass();

          _this.lastScrollLeft = scrollLeft;
        } // 同步fixed column垂直滚动


        if (_this.lastScrollTop !== scrollTop && dom !== thead) {
          // 同步水平滚动
          syncScrollTop(dom, tbody, 'scrollTop');
          syncScrollTop(dom, fixedLeft, 'scrollTop');
          syncScrollTop(dom, fixedRight, 'scrollTop');
          _this.lastScrollTop = scrollTop;
        }
      } else {
        _this.computedScrollPositionClass();
      }
    };

    _this.computedScrollPositionClass = function () {
      var _this$myRefs2 = _this.myRefs,
          tbody = _this$myRefs2.tbody,
          scrollWrap = _this$myRefs2.scrollWrap;

      if (tbody && scrollWrap) {
        var scrollToLeft = tbody.scrollLeft === 0;
        var scrollToRight = tbody.scrollLeft + 1 >= tbody.children[0].getBoundingClientRect().width - tbody.getBoundingClientRect().width;

        if (scrollToLeft) {
          scrollWrap.classList.add('scroll-position-left');
        } else {
          scrollWrap.classList.remove('scroll-position-left');
        }

        if (scrollToRight) {
          scrollWrap.classList.add('scroll-position-right');
        } else {
          scrollWrap.classList.remove('scroll-position-right');
        }
      }
    };

    _this.renderRowSelection = function () {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'checkbox';
      return function (_, record, index) {
        var rowKey = _this.findRowKey(record, index);

        var props = _this.findSelectionPropsByItem(record, index);

        return /*#__PURE__*/React.createElement("span", {
          onClick: stopPropagation
        }, /*#__PURE__*/React.createElement(RowSelection, _Object$assign({
          type: type,
          index: index,
          record: record,
          checked: !!_this.selectionKeyMap[rowKey],
          onSelectionChange: type === 'radio' ? _this.handleRadioSelect : _this.handleSelect
        }, props)));
      };
    };

    var defaultSort = props.defaultSort,
        data = props.data;
    _this.state = {
      // columns: columns || [],
      data: data || [],
      selectionKeyMap: {},
      expandRowKeyMap: {},
      sortOrder: _Object$assign({}, defaultSort),
      rowHeightMap: {}
    };
    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.computedScrollPositionClass();
    }
  }, {
    key: "registerIndexColumn",
    value: function registerIndexColumn(columns) {
      columns.unshift({
        label: '#',
        prop: 'Table__row_index',
        width: '64px',
        render: function render(t, r, i) {
          return r._roo_index || i + 1;
        }
      });
    }
  }, {
    key: "registerSelectionColumn",
    value: function registerSelectionColumn(columns, _ref) {
      var _this2 = this;

      var selectionType = _ref.selectionType,
          selectionLabel = _ref.selectionLabel;
      columns.unshift({
        label: '',
        prop: 'Table__row_selection',
        width: 60,
        align: 'center',
        render: this.renderRowSelection(selectionType),
        renderTh: function renderTh() {
          var status = _this2.selectionAllStatus;
          return selectionLabel || /*#__PURE__*/React.createElement("span", {
            onClick: stopPropagation
          }, selectionType !== 'radio' && /*#__PURE__*/React.createElement(RowSelection, {
            type: selectionType,
            checked: status === 'checked',
            half: status === 'half',
            onSelectionChange: _this2.handleSelectAll
          }));
        }
      });
    }
  }, {
    key: "registerExpandColumn",
    value: function registerExpandColumn(columns) {
      var _this3 = this;

      columns.unshift({
        label: '',
        prop: 'Table__row_expand',
        align: 'center',
        width: 60,
        render: function render(_, record, index) {
          var rowKey = _this3.findRowKey(record, index);

          var expanded = _this3.expandRowKeyMap[rowKey];
          var callbackProps = [record, index, !expanded];
          return /*#__PURE__*/React.createElement(ExpandArrow, {
            rowKey: rowKey,
            expanded: expanded,
            onChange: function onChange() {
              return _this3.handleChangeExpand(rowKey, !expanded, callbackProps);
            }
          });
        }
      });
    }
  }, {
    key: "cache",
    value: function cache(name, getter) {
      if (this.computedCache[name]) return this.computedCache[name];
      this.computedCache[name] = getter();
      return this.computedCache[name];
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      this.computedCache = {};
    }
  }, {
    key: "saveRefs",
    value: function saveRefs(name) {
      var _this4 = this;

      return function (ref) {
        _this4.myRefs[name] = ref;
      };
    }
  }, {
    key: "renderHead",
    value: function renderHead(columns, isMain) {
      var rowHeightMap = this.state.rowHeightMap;
      return /*#__PURE__*/React.createElement(TableHead, {
        columns: columns,
        onSort: this.handleSort,
        sort: this.sortOrder,
        heightMap: isMain ? undefined : rowHeightMap,
        onSyncHeight: isMain ? this.syncHeightOfIndex : undefined
      });
    }
  }, {
    key: "renderBody",
    value: function renderBody(columns, isMain) {
      var _this5 = this;

      var _this$props = this.props,
          onRowClick = _this$props.onRowClick,
          onRowDoubleClick = _this$props.onRowDoubleClick,
          expandable = _this$props.expandable,
          expandRowRender = _this$props.expandRowRender,
          rowClassName = _this$props.rowClassName,
          cellClassName = _this$props.cellClassName;
      var rowHeightMap = this.state.rowHeightMap;
      var rows = [];
      var bodyColumns = this.normalizeBodyColumns(columns);
      this.dataSource.forEach(function (row, i) {
        var key = _this5.findRowKey(row, i);

        var level = row._roo_level;
        var parVisible = (row._roo_key || []).every(function (item) {
          return _this5.expandRowKeyMap[item];
        });
        var visible = level === undefined || level === 0 || parVisible;
        var className = isFunction(rowClassName) ? rowClassName(i, row) : rowClassName;
        rows.push( /*#__PURE__*/React.createElement(TableRow, {
          index: i,
          key: key,
          data: row,
          className: className,
          cellClassName: cellClassName,
          visible: visible,
          columns: bodyColumns,
          onRowClick: onRowClick,
          onRowDoubleClick: onRowDoubleClick,
          onCellClick: _this5.handleCellClick,
          height: isMain ? undefined : rowHeightMap[i],
          onSyncHeight: isMain ? _this5.syncHeightOfIndex : undefined
        }));

        if (expandable) {
          rows.push( /*#__PURE__*/React.createElement(TableExpandRow, {
            index: i,
            key: "expand_row_".concat(key),
            data: row,
            expanded: _this5.expandRowKeyMap[key],
            colspan: bodyColumns.length,
            render: expandRowRender
          }));
        }
      });
      return /*#__PURE__*/React.createElement("tbody", null, rows);
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      var _this$props2 = this.props,
          border = _this$props2.border,
          emptyComponent = _this$props2.emptyComponent,
          scrollX = _this$props2.scrollX;

      if (!emptyComponent) {
        return null;
      }

      if (this.dataSource.length) return null;
      var style = {
        textAlign: 'center',
        padding: '20px'
      };

      if (border) {
        style.borderColor = '#E9EAF2';
        style.borderStyle = 'solid';
        style.borderWidth = '0 1px 1px';
      }

      if (this.myRefs.scrollWrap) {
        style.width = this.myRefs.scrollWrap.getBoundingClientRect().width || scrollX || '100%';
      }

      return /*#__PURE__*/React.createElement("div", {
        style: style
      }, isFunction(emptyComponent) ? emptyComponent() : emptyComponent);
    }
  }, {
    key: "renderFixedTable",
    value: function renderFixedTable(type) {
      var _this$props3 = this.props,
          scrollX = _this$props3.scrollX,
          scrollY = _this$props3.scrollY;
      var xStyle = scrollX ? {
        minWidth: scrollX
      } : undefined;
      var yStyle = scrollY ? {
        maxHeight: scrollY
      } : undefined;
      var config = {
        main: {
          headRef: this.saveRefs('thead'),
          bodyRef: this.saveRefs('tbody'),
          wrapperClassName: 'roo-table-main',
          columns: this.columns,
          xStyle: xStyle,
          yStyle: yStyle
        },
        left: {
          headRef: undefined,
          bodyRef: this.saveRefs('fixedLeft'),
          wrapperClassName: 'roo-table-fixed-left',
          columns: this.leftColumns,
          xStyle: undefined,
          yStyle: yStyle
        },
        right: {
          headRef: undefined,
          bodyRef: this.saveRefs('fixedRight'),
          wrapperClassName: 'roo-table-fixed-right',
          columns: this.rightColumns,
          xStyle: undefined,
          yStyle: yStyle
        }
      };
      var curConf = config[type];
      var overflowStyle = {
        overflowX: undefined,
        overflowY: scrollY ? 'scroll' : undefined
      };
      if (!curConf.columns.length) return null;

      if (type === 'main') {
        overflowStyle.overflowX = scrollX ? 'scroll' : undefined;
      }

      var isMain = type === 'main';
      var colgroup = /*#__PURE__*/React.createElement(Colgroup, {
        columns: curConf.columns
      });
      var thead = this.renderHead(curConf.columns, isMain);
      var tbody = this.renderBody(curConf.columns, isMain);
      var fixedLeftClass = type === 'left' ? 'roo-no-scrollbar' : '';
      return /*#__PURE__*/React.createElement("div", {
        className: curConf.wrapperClassName
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-table-header",
        ref: curConf.headRef,
        onScroll: this.handleScroll
      }, /*#__PURE__*/React.createElement("table", {
        className: this.classnames,
        style: curConf.xStyle
      }, colgroup, thead)), /*#__PURE__*/React.createElement("div", {
        className: "roo-table-body ".concat(fixedLeftClass),
        style: _Object$assign(_Object$assign({}, overflowStyle), curConf.yStyle),
        ref: curConf.bodyRef,
        onScroll: this.handleScroll
      }, /*#__PURE__*/React.createElement("table", {
        className: this.classnames,
        style: curConf.xStyle
      }, colgroup, tbody)));
    }
  }, {
    key: "renderScrollTable",
    value: function renderScrollTable(type) {
      var scrollX = this.props.scrollX;
      var xStyle = scrollX ? {
        minWidth: scrollX
      } : undefined;
      var config = {
        main: {
          bodyRef: this.saveRefs('tbody'),
          wrapperClassName: 'roo-table-main',
          columns: this.columns,
          xStyle: xStyle
        },
        left: {
          bodyRef: this.saveRefs('fixedLeft'),
          wrapperClassName: 'roo-table-fixed-left',
          columns: this.leftColumns,
          xStyle: undefined
        },
        right: {
          bodyRef: this.saveRefs('fixedRight'),
          wrapperClassName: 'roo-table-fixed-right',
          columns: this.rightColumns,
          xStyle: undefined
        }
      };
      var curConf = config[type];
      if (!curConf.columns.length) return null;
      var isMain = type === 'main';
      var colgroup = /*#__PURE__*/React.createElement(Colgroup, {
        columns: curConf.columns
      });
      var thead = this.renderHead(curConf.columns, isMain);
      var tbody = this.renderBody(curConf.columns, isMain);
      var fixedLeftClass = type === 'left' ? 'roo-no-scrollbar' : '';
      return /*#__PURE__*/React.createElement("div", {
        className: curConf.wrapperClassName
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-table-body ".concat(fixedLeftClass),
        style: {
          overflowX: scrollX && type === 'main' ? 'scroll' : undefined
        },
        ref: curConf.bodyRef,
        onScroll: this.handleScroll
      }, /*#__PURE__*/React.createElement("table", {
        className: this.classnames,
        style: curConf.xStyle
      }, colgroup, thead, tbody)));
    }
  }, {
    key: "render",
    value: function render() {
      /**
       * 说下这里为啥这么做
       * 用 computedCache 对部分需要计算的getter进行缓存
       * 每次render开始清空缓存
       * 保证被cache的 getter 函数在同一次render只执行一次，假装能提升一点性能
       */
      this.clearCache();
      var _this$props4 = this.props,
          scrollY = _this$props4.scrollY,
          loading = _this$props4.loading,
          className = _this$props4.className,
          style = _this$props4.style;
      var tableStyle = style;

      if (!this.dataSource.length) {
        tableStyle = _Object$assign(_Object$assign({}, style), {
          overflowX: 'scroll'
        });
      }

      if (scrollY && this.dataSource.length) {
        return /*#__PURE__*/React.createElement(ReactResizeDetector, {
          handleWidth: true,
          skipOnMount: true,
          refreshRate: 300,
          refreshMode: "debounce",
          onResize: this.handleForceUpdate
        }, /*#__PURE__*/React.createElement("div", {
          className: "roo-table-scrollable ".concat(className || ''),
          style: tableStyle,
          ref: this.saveRefs('scrollWrap')
        }, /*#__PURE__*/React.createElement(Loading, {
          visible: loading
        }, this.renderFixedTable('main'), this.renderFixedTable('left'), this.renderFixedTable('right'), this.renderEmpty())));
      }

      return /*#__PURE__*/React.createElement(ReactResizeDetector, {
        handleWidth: true,
        skipOnMount: true,
        refreshRate: 300,
        refreshMode: "debounce",
        onResize: this.handleForceUpdate
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-table-scrollable ".concat(className || ''),
        style: tableStyle,
        ref: this.saveRefs('scrollWrap')
      }, /*#__PURE__*/React.createElement(Loading, {
        visible: loading
      }, this.renderScrollTable('main'), this.renderScrollTable('left'), this.renderScrollTable('right'), this.renderEmpty())));
    }
  }, {
    key: "classnames",
    get: function get() {
      var cs = ['roo-table'];
      var _this$props5 = this.props,
          border = _this$props5.border,
          stripe = _this$props5.stripe,
          hover = _this$props5.hover;
      if (border) cs.push('roo-table-bordered');
      if (stripe) cs.push('roo-table-striped');
      if (hover) cs.push('roo-table-hover');
      return cs.join(' ');
    }
  }, {
    key: "sortOrder",
    get: function get() {
      return this.props.sortOrder || this.state.sortOrder;
    }
  }, {
    key: "columnsMap",
    get: function get() {
      var _this6 = this;

      return this.cache('columnsMap', function () {
        var _this6$props = _this6.props,
            showIndex = _this6$props.showIndex,
            selectable = _this6$props.selectable,
            selectionType = _this6$props.selectionType,
            selectionLabel = _this6$props.selectionLabel,
            expandable = _this6$props.expandable,
            hasTree = _this6$props.hasTree;
        var columns = _this6.props.columns;
        var left = [];
        var right = [];
        var other = columns.filter(function (c, i) {
          if (!c.prop && c.children) c.prop = "roo_table_group_".concat(i);
          if (!c.fixed) return true;
          if (!c.width) throw new Error('Table: 使用`fixed`属性的Column必须设置`width`属性');
          if (c.fixed === 'left') left.push(c);else right.push(c);
          return false;
        });
        var farLeft = left.length ? left : other;

        if (hasTree) {
          _this6.registerTreeColumn(farLeft);
        }

        if (showIndex) {
          _this6.registerIndexColumn(farLeft);
        }

        if (selectable) {
          _this6.registerSelectionColumn(farLeft, {
            selectionType: selectionType,
            selectionLabel: selectionLabel
          });
        }

        if (expandable) {
          _this6.registerExpandColumn(farLeft);
        }

        var main = left.concat(other).concat(right);
        var columnsMap = {
          main: main,
          left: left,
          right: right
        };
        return columnsMap;
      });
    }
  }, {
    key: "columns",
    get: function get() {
      return this.columnsMap.main;
    }
  }, {
    key: "leftColumns",
    get: function get() {
      return this.columnsMap.left;
    }
  }, {
    key: "rightColumns",
    get: function get() {
      return this.columnsMap.right;
    }
  }, {
    key: "expandRowKeyMap",
    get: function get() {
      var _this7 = this;

      return this.cache('expandRowKeyMap', function () {
        var expandRowKeys = _this7.props.expandRowKeys;
        if (expandRowKeys) return reduceKeys(expandRowKeys);
        return _this7.state.expandRowKeyMap;
      });
    }
  }, {
    key: "selectionKeyMap",
    get: function get() {
      var _this8 = this;

      return this.cache('selectionKeyMap', function () {
        var selectionKeys = _this8.props.selectionKeys;
        if (selectionKeys) return reduceKeys(selectionKeys);
        return _this8.state.selectionKeyMap;
      });
    }
  }, {
    key: "selectionAllStatus",
    get: function get() {
      var selectedKeys = _Object$keys(this.selectionKeyMap);

      if (selectedKeys.length === 0) return 'unchecked';
      if (selectedKeys.length === this.checkableKeys.length) return 'checked';
      return 'half';
    }
  }, {
    key: "dataSource",
    get: function get() {
      var _this9 = this;

      return this.cache('dataSource', function () {
        var _this9$sortOrder = _this9.sortOrder,
            prop = _this9$sortOrder.prop,
            order = _this9$sortOrder.order;
        var _this9$props = _this9.props,
            sorter = _this9$props.sorter,
            hasTree = _this9$props.hasTree;
        var originData = _this9.state.data;
        var data = originData;

        if (hasTree) {
          data = _this9.flatTreeTable(originData);
        }

        if (!sorter || !prop || !order) return data;

        if (typeof sorter === 'function') {
          return _toConsumableArray(data).sort(function (a, b) {
            return sorter(a, b, {
              prop: prop,
              order: order
            });
          });
        }

        return _toConsumableArray(data).sort(function (a, b) {
          var d = order === 'asc' ? 1 : -1;
          return a[prop] > b[prop] ? d : -d;
        });
      });
    }
  }, {
    key: "checkableKeys",
    get: function get() {
      var _this10 = this;

      return this.cache('checkableKeys', function () {
        var arr = [];

        _this10.dataSource.forEach(function (v, i) {
          if (!_this10.findSelectionPropsByItem(v, i).disabled) {
            arr.push(_this10.findRowKey(v, i));
          }
        });

        return arr;
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // const propColumnsWithFuncString = jsonFuncToString(props.columns);
      // const stateColumnsWithFuncString = jsonFuncToString(state.columns);
      if (!isEqual(props.data, state.data)) {
        return {
          // columns: props.columns,
          data: props.data,
          selectionKeyMap: {},
          expandRowKeyMap: {}
        };
      }

      return null;
    }
  }]);

  return Table;
}(React.Component);

Table.defaultProps = {
  dataSource: [],
  rowKey: function rowKey(record, index) {
    return "".concat(index);
  },
  defaultSort: {
    key: '',
    dir: 'asc'
  },
  sorter: false,
  onSortChange: function onSortChange() {
    return undefined;
  },
  emptyComponent: ''
};
polyfill(Table);
export default Table; // TODO
// 固定列不同步的问题： index、checkbox、expand 都需要处理